import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import CabsBreadcrumbs from './CabsBreadcrumbs';

const CabsEnquirySuccess = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const leadId = searchParams.get('leadId');
  return (
    <section className="space-y-6">
      <CabsBreadcrumbs
        items={[{ label: 'Home', to: '/' }, { label: 'Cabs', to: '/cabs' }, { label: 'Enquiry Success' }]}
      />
      <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
        <h1 className="text-2xl font-semibold text-slate-900">Enquiry received</h1>
        <p className="mt-2 text-sm text-slate-600">Our team will contact you shortly with next steps.</p>
        {leadId && (
          <p className="mt-3 text-xs text-slate-500">
            Your lead reference: <span className="font-semibold text-slate-900">{leadId}</span>
          </p>
        )}
        <div className="mt-4 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="rounded-full bg-slate-900 px-4 py-2 text-xs font-semibold text-white"
          >
            Back to Home
          </Link>
          <Link
            to={`/cabs${location.search}`}
            className="rounded-full border border-slate-200 px-4 py-2 text-xs font-semibold text-slate-600"
          >
            Book another cab
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CabsEnquirySuccess;
